export interface AdminUser {
  id: string;
  email: string;
  name: string;
  role: string;
  admin_role?: string | null;
  is_super_admin?: boolean;
}

export interface LoginResponse {
  access_token: string;
  expires_in: number;
  user: AdminUser;
  permissions?: string[];
  is_super_admin?: boolean;
}

/// v1.5: returned by /login when the admin has email-OTP MFA enabled. The client
/// must complete /verify-otp with the challenge token before a session is issued.
export interface MfaChallengeResponse {
  mfa_required: true;
  challenge_token: string;
  masked_email: string;
  message?: string;
}

export interface RecoveryCodesResponse {
  data: { recovery_codes: string[] };
}

export interface ApiError {
  error: { code: string; message: string };
}

export function isMfaChallenge(res: unknown): res is MfaChallengeResponse {
  return !!res && typeof res === 'object' && (res as MfaChallengeResponse).mfa_required === true;
}

export function isLoginResponse(res: unknown): res is LoginResponse {
  return !!res && typeof res === 'object' && typeof (res as LoginResponse).access_token === 'string';
}
